module.exports = ".spacing-button {\n    margin-top: 22px;\n}\n\n.containerBtnPC {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n\n.btnSalve {\n    margin-left: 28px;\n    margin-right: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/project-cost/project-cost-create/projects-cost-create.component.css
// module id = ./src/app/views/project-cost/project-cost-create/projects-cost-create.component.css
// module chunks = main